/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/password-change', {
      templateUrl: require('./force-change.template.html'),
      title: 'Passwort ändern',
    });
}
